@if(!route?.length && !link?.length){
    <button class=""
            [ngClass]="classes"
            [classList]="customClasses"
            [disabled]="disabled"
            (click)='clickButton()'>
        <ng-content select=".button_body"></ng-content>

        @if (icon) {
            <img
                    [ngClass]="imgCustomClasses"
                    [src]="icon"
                    [alt]="icon"
            >
        }
        {{mustTranslate? (text | translate) : text}}
    </button>
} @else if (link){
    <a class=""
       [ngClass]="classes"
       [classList]="customClasses"
       [href]="link">
        @if (icon) {
            <img
                    [ngClass]="imgCustomClasses"
                    [src]="icon"
                    [alt]="icon"
            >
        }
        {{mustTranslate? (text | translate) : text}}
    </a>
} @else if (route){
    <a class=""
       [ngClass]="classes"
       [classList]="customClasses"
       [routerLink]="route">
        @if (icon) {
            <img
                    [ngClass]="imgCustomClasses"
                    [src]="icon"
                    [alt]="icon"
            >
        }
        {{mustTranslate? (text | translate) : text}}
    </a>
}

